export default "__VITE_ASSET__e5e0ece2__"